import { Box } from "@/components/layout/flexbox";
import { MemberAssistantBox } from "@/components/pages_logged_in/workspace-admin/MemberAssistantBox";
import { MenuHeader } from "@/components/pieces/menu/MenuHeader";
import { MainAssistant } from "@/types/workspaces";

interface MenuAssistantProps {
  member: MainAssistant;
  onClose: () => void;
  onBackLink: () => void;
}

export function MenuAssistant({
  member,
  onClose,
  onBackLink,
}: MenuAssistantProps) {
  return (
    <Box width={1} m={1}>
      <MenuHeader
        onBackLink={() => {
          onBackLink();
        }}
        onClose={() => {
          onClose();
        }}
        label="Assistants"
      />
      <Box m={3}>
        <MemberAssistantBox member={member} isMenu />
      </Box>
    </Box>
  );
}
